"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactLoadingSkeleton = _interopRequireDefault(require("react-loading-skeleton"));
var _react2 = require("@emotion/react");
var _Column = _interopRequireDefault(require("../../layout/Column"));
var _Row = _interopRequireDefault(require("../../layout/Row"));
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function OrderItemSkeleton() {
  return /*#__PURE__*/_react.default.createElement(_Column.default, null, /*#__PURE__*/_react.default.createElement(_reactLoadingSkeleton.default, {
    height: 8,
    width: 120
  }), /*#__PURE__*/_react.default.createElement(_Row.default, {
    gap: 10
  }, /*#__PURE__*/_react.default.createElement(_reactLoadingSkeleton.default, {
    height: 54,
    width: 54
  }), /*#__PURE__*/_react.default.createElement(_Column.default, {
    styles: cssContentStyles
  }, /*#__PURE__*/_react.default.createElement(_reactLoadingSkeleton.default, {
    height: 15,
    width: 200
  }), /*#__PURE__*/_react.default.createElement(_reactLoadingSkeleton.default, {
    height: 12,
    count: 2
  }), /*#__PURE__*/_react.default.createElement(_Row.default, {
    gap: 5
  }, /*#__PURE__*/_react.default.createElement(_reactLoadingSkeleton.default, {
    height: 15,
    width: 20
  }), /*#__PURE__*/_react.default.createElement(_reactLoadingSkeleton.default, {
    height: 15,
    width: 40
  })))));
}
const cssContentStyles = (0, _react2.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
var _default = exports.default = OrderItemSkeleton;